import StickySidebar from "sticky-sidebar";
// import Player from '@vimeo/player';
// import zenscroll from 'zenscroll';
import { debounce } from "js-utils/src/function";
// import { getElements } from 'js-utils/src/selector';

import init from "../../common/base/init";

// sticky share buttons

init(() => {
  let postShare = document.querySelector(".the-article__share");
  if (!postShare) return;

  let fixedHeader = document.querySelector(".header--fixed");
  let topSpacing = fixedHeader ? 100 : 73;

  let sticky = null;
  const stickyMQ = "(min-width: 48.0625em)"; // 'medium' in SASS
  const stickyConfig = {
    topSpacing: topSpacing,
    bottomSpacing: 20,
    minWidth: 640
  };

  const toggleSticky = () => {
    if (window.matchMedia(stickyMQ).matches) {
      if (!sticky) {
        sticky = new StickySidebar(".the-article__share", stickyConfig);
      }
    } else {
      if (sticky) {
        sticky.destroy();
        sticky = null;
      }
    }
  };

  toggleSticky();
  window.addEventListener("resize", debounce(300, toggleSticky));
});

// video sections

init(() => {
  const container = document.querySelector(".the-article__video-sections");
  if (!container) return;

  const toggler = document.querySelector(
    ".the-article__video .-video-sections-toggler"
  );
  const video = document.querySelector(".the-article__video iframe");
  const player = new Player(video);
  const buttons = getElements("button", container);

  toggler.addEventListener("click", e => {
    e.preventDefault();
    toggler.classList.toggle("--active");
    container.classList.toggle("--visible");
  });

  buttons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      player.setCurrentTime(button.getAttribute("data-time"));
      zenscroll.center(video);
      video.focus();
    });
  });
});
